import script from "./UserView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserView.vue?vue&type=script&setup=true&lang=ts"

import "./UserView.vue?vue&type=style&index=0&id=3cca7822&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cca7822"]])

export default __exports__